import { useEffect } from "react";

import { observeRecaptchaOverlayPointerEvents } from "@/helpers/recaptcha-overlay";

/**
 * While `active`, keeps the reCAPTCHA challenge overlay clickable even on
 * browsers that lack the CSS `:has()` rule the theme relies on. Pair with
 * `recaptchaPersistentElements` on the surrounding modal so those same clicks
 * don't dismiss it.
 */
const useRecaptchaOverlayPointerEvents = (active: boolean): void => {
  useEffect(() => {
    if (!active) return;

    return observeRecaptchaOverlayPointerEvents();
  }, [active]);
};

export default useRecaptchaOverlayPointerEvents;
